import FasterHttpClient from 'Faster/network/FasterHttpClient';
import GetServerDateRequest from 'Faster/request/GetServerDateRequest';

class ServerDateService {
  private fasterClient: FasterHttpClient;

  public constructor(fasterClient: FasterHttpClient) {
    this.fasterClient = fasterClient;
  }

  public async get(): Promise<Date> {
    const getServerDateRequest = new GetServerDateRequest();
    try {
      const request = this.fasterClient.executeWithoutRetry(getServerDateRequest);
      return request.then((response): Date => {
        const serverTime = response.headers.get('localtime');
        return new Date(serverTime);
      });
    } catch (error) {
      console.warn('Failed to get ServerDate, it will use local time instead.', error);
      return null;
    }
  }
}

export default ServerDateService;
